/* Custom JS Code  */

$(document).ready(function(){

    /* get span object */
    let plateText =  $( ".div_plate .plate_text" );

    /* get text field object */
    let textField = $( "#text_field" );

    /* get text field attribute maxlength */
    let maxlength = textField.attr( "maxlength" );
    /* parse from string to number*/
    maxlength = parseInt(maxlength, 10)

    /* get placeholder of text field */
    let placeholder = textField.attr("placeholder");

    // $( plateText ).change(function() {
        // $( this ).attr('maxlength', maxlength - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  );
        // console.log( maxlength - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2 );
        // console.log("jop");
    // });

    // textField.on('change input', function() {
    //     console.log('Input value changed to: ' + $(this).val());
    // });



    /* function for key input in text field */
    // $( "#text_field" ).on("input", function() {
    textField.on("input", function() {

        /* get text field attribute maxlength */
        // let maxlength = $( this ).attr( "maxlength" );

        /* the android keyboard does not accept the maxlength attribute, this code solve this issue */
        // if ( $( this ).val().length > maxlength) {
        //     $( this ).val( $( this ).val().slice(0, maxlength) );
        // }


        // if ( $( "#div_info_text span" ).html() < 1 ) {
        //     $( this ).val( $( this ).val().slice(0, maxlength - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  )  );
        // }

        /* the android keyboard does not accept the maxlength attribute, this code solve this issue */
        // $( this ).val( $( this ).val().slice(0, maxlength - textField.val().length + $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  )  );
        $( this ).val( $( this ).val().slice(0, maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * ( 0.5 - 1 ) - $(".plate_text_symbols[data-letter-width='1.5']").length * ( 1.5 - 1 ) - $(".plate_text_symbols[data-letter-width='2']").length * ( 2 - 1 ) - $(".plate_text_symbols[data-letter-width='3']").length * ( 3 - 1 ) ) );



        /* current positon of the cursor in the text field */
        let cursPos = this.selectionStart;

        /* input field only valid for certain characters */
        let raw_text = $(this).val();
        let return_text = raw_text.replace(/[^0-9a-zA-ZäÄüÜöÖëËñÑ♥½ЯƎ.@$!?&#'_♣♆☛★\-\+ ]/g, '');

        $(this).val(return_text);

        /* change text field value to uppercase */
        $(this).val($(this).val().toUpperCase());

        /* position the cursor */
        this.setSelectionRange(cursPos, cursPos);

        /* change plate text */
        // $( ".div_plate .plate_text" ).html($( this ).val());
        plateText.html($( this ).val());

        /* function wrap symbols in span elements in plate text */
        wrapSymbols();

        /* if input field empty show placeholder text */
        if( !$( this ).val() ) {

            // let placeholder = $( this ).attr("placeholder");
            // $( ".div_plate .plate_text" ).html(placeholder);
            plateText.html(placeholder);
        }

        /* change text plate font size */
        changeFontSize();

        /* change count number */
        changeCountNbr();

        /* text_field  on input function end */

        // $(".bc_carbon").css("background-size", textField.val() + "px");
        // $("label[for=bc_carbon]").css("background-size", textField.val() + "px");

        /* some symbols count more or less than one space */
        $( textField ).attr('maxlength', maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * ( 0.5 - 1 ) - $(".plate_text_symbols[data-letter-width='1.5']").length * ( 1.5 - 1 ) - $(".plate_text_symbols[data-letter-width='2']").length * ( 2 - 1 ) - $(".plate_text_symbols[data-letter-width='3']").length * ( 3 - 1 ) );

        // $( this ).attr('maxlength', maxlength + $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  );
        // $( this ).attr('maxlength', maxlength + $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  );
        // $( this ).attr('maxlength', maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 1.5 - $(".plate_text_symbols[data-letter-width='2']").length * 2 - $(".plate_text_symbols[data-letter-width='3']").length * 3  );
        // console.log( "key", maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 1.5 - $(".plate_text_symbols[data-letter-width='2']").length * 2 - $(".plate_text_symbols[data-letter-width='3']").length * 3);
        // console.log( "key", maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 1.5 - $(".plate_text_symbols[data-letter-width='2']").length * 2 - $(".plate_text_symbols[data-letter-width='3']").length * 3);

    });




    $('#showSelected').on('click', function(){

        var text = "";
        if (window.getSelection) {
            text = window.getSelection().toString();
        } else if (document.selection && document.selection.type != "Control") {
            text = document.selection.createRange().text;
        }

        alert(text);
    });





    /* get button object */
    let umlauts = $( ".umlauts" );

    /* insert umlauts or symbols in text field */
    // $(".umlauts").click(function(){
    umlauts.click(function(){

        let selectedText = '';
        if (window.getSelection) {
            selectedText = window.getSelection().toString();
            // console.log(selectedText);
        }

        // if ( $(this).html() !== "Ǝ" ) {
        //     console.log( $(this).html() );
        // }
        // console.log( $(this)[0] );
        // console.log( $(this).innerHTML() );

        /* get text field object */
        // let textField = $( "#text_field" );

        /* current positon of the cursor in the text field */
        let cursPos = textField[0].selectionStart;
        let cursPos2 = textField[0].selectionEnd;

        /* get text field value */
        let textFieldVal = textField.val();

        /* get umlauts button html */
        // let umlautsHtml = $( this ).html();
        let umlautsHtml = $( this ).text();

        /* get text field attribute maxlength */
        // let maxlength = textField.attr( "maxlength" );

        /* if text value less than maxlength or text selected */
        // if ( textFieldVal.length < maxlength || cursPos2 - cursPos > 0 ) {
        // if ( ( textFieldVal.length < maxlength || cursPos2 - cursPos > 0 )  && $( "#div_info_text span" ).html() >= 0   )   {
        if (  ( ( textFieldVal.length + $(".plate_text_symbols[data-letter-width='0.5']").length * ( 0.5 - 1) + $(".plate_text_symbols[data-letter-width='1.5']").length * ( 1.5 - 1 ) + $(".plate_text_symbols[data-letter-width='2']").length * ( 2 - 1 ) + $(".plate_text_symbols[data-letter-width='3']").length * ( 3 - 1 ) ) < maxlength && $( "#div_info_text span" ).html() > 0.4 ) || cursPos2 - cursPos > 0 )   {


            // $( "#text_field" ).attr('maxlength', maxlength - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  );

            // if ( $( "#div_info_text span" ).html() == 0 ) {
            //     $( this ).val( $( this ).val().slice(0, maxlength - $(".plate_text_symbols[data-letter-width='2']").length )  );
            // }

                                                                                   /* wenn größer als 0 dann machen, hier wenn größer als  */
            // if ( ( $(this).html() == "♣" || $(this).html() == "♆" || $(this).html() == "♥" ) && ( $( "#div_info_text span" ).html() == 1 && cursPos2 - cursPos == 0 ) ) {
            // if ( ( $(this).html() == "♣" || $(this).html() == "♆" || $(this).html() == "♥" ) && ( $( "#div_info_text span" ).html() <= 1 && cursPos2 - cursPos == 0 ) ) {
            // if ( ( $(this).html() == "♣" || $(this).html() == "♆" || $(this).html() == "♥" ) && ( ( $( "#div_info_text span" ).html() == 1 && cursPos2 - cursPos == 0 ) || ( $( "#div_info_text span" ).html() == 0 && cursPos2 - cursPos == 1 )       )    ) {
            // if ( ( $(this).html() == "♣" || $(this).html() == "♆" || $(this).html() == "♥" ) && ( ( $( "#div_info_text span" ).html() == 1 && cursPos2 - cursPos == 0 ) || ( $( "#div_info_text span" ).html() == 0 && (/* cursPos2 - cursPos == 1 ||*/ selectedText == "♣" )   )       )    ) {
            // if ( ( $(this).html() == "♣" || $(this).html() == "♆" || $(this).html() == "☛" ) && ( ( $( "#div_info_text span" ).html() == 1 && cursPos2 - cursPos == 0 ) || ( $( "#div_info_text span" ).html() == 0  && ( cursPos2 - cursPos == 1  /*selectedText != "♣"  || selectedText != "♆"  || selectedText != "♥"*/ )  )    )    ) {
            if (
                ( $(this).html() == "♣" || $(this).html() == "♆" ) &&
                (
                    ( $( "#div_info_text span" ).html() < 2 && cursPos2 - cursPos == 0 ) ||
                    ( $( "#div_info_text span" ).html() == 0 && cursPos2 - cursPos == 1 && ( selectedText != "♆" && selectedText != "♣" ) )
                )
            ) {
                textField.focus();
                return;
            } else if (
                $(this).html() == "☛" &&
                (
                    ( $( "#div_info_text span" ).html() < 3 && cursPos2 - cursPos < 1 ) ||
                    ( $( "#div_info_text span" ).html() < 2 && cursPos2 - cursPos < 2 ) ||
                    // ( $( "#div_info_text span" ).html() < 1 && cursPos2 - cursPos < 3 )
                    // ( $( "#div_info_text span" ).html() < 1 /* && cursPos2 - cursPos < 3*/ && ( selectedText != "♥♥" && selectedText != "★★"  ) ) ||
                    ( $( "#div_info_text span" ).html() < 1 && cursPos2 - cursPos < 3 )
                    // ( $( "#div_info_text span" ).html() == 0.5 && cursPos2 - cursPos == 2 && ( selectedText != "♥♥" && selectedText != "★★"  ) && ( selectedText != "♥★" && selectedText != "★♥"  ) ) ||
                    // ( $( "#div_info_text span" ).html() == 0 && cursPos2 - cursPos == 2 )
                )
            ) {
                textField.focus();
                return;
            } else if (
                ( $(this).html() == "♥" || $(this).html() == "★" ) &&
                (
                    ( $( "#div_info_text span" ).html() < 1.5 && cursPos2 - cursPos == 0 ) ||
                    ( $( "#div_info_text span" ).html() == 0 && cursPos2 - cursPos == 1 && ( selectedText != "★" && selectedText != "♥" ) )
                )
            ) {
                textField.focus();
                return;
            } else {

                /* insert umlauts or symbols in the text field */
                textField.val( textFieldVal.slice(0, cursPos) + umlautsHtml + textFieldVal.slice(cursPos2) );

                /* add + 1 to the current position of the cursor, so that it moves to the right */
                cursPos = cursPos + 1;

                /* position the cursor */
                textField[0].setSelectionRange(cursPos, cursPos);

                /* get text value */
                // textval = $( "#text_field" ).val();
                let textval = textField.val();

                /* change plate text */
                // $(".div_plate .plate_text").html(textval);
                plateText.html(textval);

                /* function wrap symbols in span elements in plate text */
                wrapSymbols();

                /* change plate text font size */
                changeFontSize();

                /* change info count number */
                changeCountNbr();


            }




        }

        textField.focus();

        // $( textField ).attr('maxlength', maxlength + $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='2']").length - $(".plate_text_symbols[data-letter-width='3']").length * 2  );
        $( textField ).attr('maxlength', maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * ( 0.5 - 1 ) - $(".plate_text_symbols[data-letter-width='1.5']").length * ( 1.5 - 1 ) - $(".plate_text_symbols[data-letter-width='2']").length * ( 2 - 1 ) - $(".plate_text_symbols[data-letter-width='3']").length * ( 3 - 1 ) );
        // console.log( "click", maxlength - $(".plate_text_symbols[data-letter-width='0.5']").length * 0.5 - $(".plate_text_symbols[data-letter-width='1.5']").length * 1.5 - $(".plate_text_symbols[data-letter-width='2']").length * 2 - $(".plate_text_symbols[data-letter-width='3']").length * 3);
        /* umlauts click function end */
    });


    /* get label object */
    let textColorLabel = $( ".textColor label" );

    /* get for attribute */
    // let forAttr = textColorLabel.attr("for");

    /* get image object */
    // let plateBorder = $( ".div_plate .plate_border" );
    let plateBorder = $( ".div_plate .plate_plain" );

    /* function for changing plate text font color and border color */
    // $( ".textColor label" ).click( function() {
    textColorLabel.click( function() {

        /* get for attribute */
        let forAttr = $( this ).attr("for");






        if ( forAttr === "c_carbon" ) {

            if ( plateText.not( "c_carbon" ) ) {

                plateText.css("color", '');
                plateText.addClass( "c_carbon" );


                plateBorder.css("background-color", '');
                plateBorder.addClass( "c_carbon_border" );



            }

        } else {

            if ( plateText.hasClass( "c_carbon" ) ) {
                plateText.removeClass("c_carbon")


                plateBorder.removeClass("c_carbon_border")
            }

            /* change plate text color */
            plateText.css("color", '#'+ forAttr.substring (2));
            plateBorder.css("background-color", '#'+ forAttr.substring (2));
        }











        /* change plate text color */
        // $( ".div_plate .plate_text" ).css("color", '#'+ forAttr.substring (2));
        // plateText.css("color", '#'+ forAttr.substring (2));

        /* object for different colors and css filters */
        // let colors = {
        //     white: "invert(97%) sepia(7%) saturate(0%) hue-rotate(13deg) brightness(106%) contrast(100%)",
        //     yellow: "invert(90%) sepia(60%) saturate(4844%) hue-rotate(0deg) brightness(100%) contrast(103%)",
        //     red: "invert(16%) sepia(72%) saturate(7375%) hue-rotate(359deg) brightness(99%) contrast(118%)",
        //     green: "invert(22%) sepia(73%) saturate(2706%) hue-rotate(105deg) brightness(103%) contrast(103%)",
        //     blue: "invert(11%) sepia(78%) saturate(5109%) hue-rotate(244deg) brightness(108%) contrast(159%)",
        //     gold: "invert(70%) sepia(64%) saturate(682%) hue-rotate(2deg) brightness(109%) contrast(102%)",
        //     silver: "invert(51%) sepia(0%) saturate(84%) hue-rotate(175deg) brightness(99%) contrast(87%)",
        //     black: "invert(0%) sepia(100%) saturate(0%) hue-rotate(36deg) brightness(94%) contrast(101%)"
        // };

        /* get color name of the radio button */
        let colorpicker = $( this ).prev().val();

        /* change plate border color */
        // $( ".div_plate .plate_border" ).css({
/*        plateBorder.css({

            '-webkit-filter' : colors[colorpicker],
            '-moz-filter'    : colors[colorpicker],
            '-o-filter'      : colors[colorpicker],
            '-ms-filter'     : colors[colorpicker],
            'filter'         : colors[colorpicker]
        });*/

        /* textColor label click function end */
    });




    /* get label object */
    let backgrColorLabel = $( ".backgrColor label" );

    /* get div object */
    // let backgrLayer = $( ".plate_plain" );
    let backgrLayer = $( ".div_plate_text" );

    // let backgrLayer2 = $( ".plate_plain" );
    let backgrLayer2 = $( ".div_plate" );

    /* function for changing plate background color */
    // $( ".backgrColor label" ).click(function(){
    backgrColorLabel.click(function(){

        let forAttr = $( this ).attr("for");

        if ( forAttr === "bc_carbon" ) {

            if ( backgrLayer.not( "bc_carbon" ) ) {

                backgrLayer.css("background-color", '');
                backgrLayer.addClass( "bc_carbon" );
                // backgrLayer2.css("border-color", '#ffffff');
                backgrLayer2.addClass( "bc_carbon" );

            }

        } else {

            if ( backgrLayer.hasClass( "bc_carbon" ) ) {
                backgrLayer.removeClass("bc_carbon")
                backgrLayer2.removeClass("bc_carbon")
            }

            backgrLayer.css("background-color", '#'+ forAttr.substring (3));
            backgrLayer2.css("background-color", '#'+ forAttr.substring (3));

        }
    });

    let productFormButton = $( ".product-form__buttons" );

    /* alert message if text field is empty */
    // $( ".product-form__buttons" ).click(function(){
    productFormButton.click(function(){

        // if ( $( "#text_field").length ) {
        if ( textField.length ) {

            // let textField = $( "#text_field" );

            if (!textField.val().trim()) {

                alert('Please customize the plate text.');
                textField.focus();
                return false;
            }
        }
    });

    // let oneSize = $( ".plate_text_symbols_one_size"  );

    /* function change font size */
    function changeFontSize()  {

        // if ( $( "#text_field" ).val().length > 9 ) {
        // if ( textField.val().length > 9 ) {
        // if ( ( textField.val().length + $(".plate_text_symbols[data-letter-width='2']").length ) > 9 ) {
        if ( ( textField.val().length + $(".plate_text_symbols[data-letter-width='0.5']").length * ( 0.5 - 1 ) + $(".plate_text_symbols[data-letter-width='1.5']").length * ( 1.5 - 1) + $(".plate_text_symbols[data-letter-width='2']").length ) * ( 2 - 1 ) + $(".plate_text_symbols[data-letter-width='3']").length * ( 3 - 1 )  > 9 ) {

            // if ( $( ".div_plate .plate_text" ).not( "small_font" ) ) {
            if ( plateText.not( "small_font" ) ) {

                // $( ".div_plate .plate_text"  ).addClass( "small_font" );
                plateText.addClass( "small_font" );
                $( ".plate_text_symbols_one_size"  ).addClass( "symbol_one_size" );
                // oneSize.addClass( "symbol_one_size" );
            }
        } else {

            // if ( $( ".div_plate .plate_text" ).hasClass( "small_font" ) ) {
            if ( plateText.hasClass( "small_font" ) ) {

                // $ (".div_plate .plate_text" ).removeClass("small_font");
                plateText.removeClass("small_font");
                $( ".plate_text_symbols_one_size" ).removeClass("symbol_one_size");
                // oneSize.removeClass("symbol_one_size");
            }
        }
    }


    let infoTextSpan = $( "#div_info_text span" );

    /* function change count number */
    function  changeCountNbr() {

        // let maxlength = $( "#text_field" ).attr( "maxlength" );
        // let infoNbr = $( "#text_field" ).val().length;
        let infoNbr = textField.val().length;
        // $( "#div_info_text span" ).html(maxlength - infoNbr);


        /* read the data-attribute of the symbols to get their width */
        let symbolWidth0_5 = $(".plate_text_symbols[data-letter-width='0.5']").length;
        let symbolWidth1_5 = $(".plate_text_symbols[data-letter-width='1.5']").length;
        let symbolWidth2 = $(".plate_text_symbols[data-letter-width='2']").length;
        let symbolWidth3 = $(".plate_text_symbols[data-letter-width='3']").length;

        /* substracts text field value included symbol width from max attribute of the text field */
        infoTextSpan.html(maxlength - infoNbr - symbolWidth0_5 * ( 0.5 - 1 ) - symbolWidth1_5 * ( 1.5 - 1 ) - symbolWidth2 * ( 2 - 1 ) - symbolWidth3 * ( 3 - 1 ) );
    }









    /* function wrap symbols in span elements in plate text */
    function wrapSymbols() {

        /* create object */
        let chars = {
            '½' : '<span class="plate_text_symbols" data-letter-width="0.5">½</span>',
            '★' : '<span class="plate_text_symbols plate_text_symbols_one_size plate_text_plus" data-letter-width="1.5">★</span>',
            '♥' : '<span class="plate_text_symbols plate_text_symbols_one_size plate_text_heart" data-letter-width="1.5">&hearts;</span>',
            '♣' : '<span class="plate_text_symbols plate_text_symbols_one_size plate_text_can" data-letter-width="2">♣</span>',
            '♆' : '<span class="plate_text_symbols plate_text_symbols_one_size plate_text_finger" data-letter-width="2">♆</span>',
            '☛' : '<span class="plate_text_symbols plate_text_symbols_one_size plate_text_finger" data-letter-width="3">☛</span>',
            ' ' : '<span class="plate_text_symbols">&nbsp;</span>',
            // '$':'<span class="plate_text_symbols plate_text_symbols_one_size" plate_text_dollar>$</span>',
            // '@':'<span class="plate_text_symbols plate_text_symbols_one_size plate_text_at">@</span>',
            // '#':'<span class="plate_text_symbols plate_text_symbols_one_size plate_text_hashtag">#</span>',
            '+':'<span class="plate_text_symbols plate_text_symbols_one_size plate_text_plus">+</span>'
        };

        /* get html */
        let plateTextHtml = plateText.html();
        // let plateText = $( ".div_plate .plate_text" ).html();
        // plateText = plateText.replace(/[♥@$#\+ ]/g, m => chars[m]);
        /* replaces some chars with aboves objects values */
        // plateTextHtml = plateTextHtml.replace(/[♥@$#\+ ]/g, m => chars[m]);
        plateTextHtml = plateTextHtml.replace(/[♥♣♆☛★½\+ ]/g, m => chars[m]);

        /* update plate text html with the reverse letters */
        plateText.html(plateTextHtml);
        // $( ".div_plate .plate_text" ).html(plateText);
    }

    /* get button object */
    let divSelectBtn = $( ".div_select button" );

    /* get div object */
    let divSelect = $( ".div_select" );

    /* function opens ul elment with the flags inside */
    // $( ".div_select button" ).on( "click" , function(){
    divSelectBtn.on( "click" , function(){

        /* add class to div */
        divSelect.addClass( "active" );



        /* needed as long as overscroll-behavior-y doesn't work on ios  */
        if ( $( ".div_select.active ul" ).scrollTop() == 0 ) {
            $( ".div_select.active ul" ).scrollTop(1);
        }

        $( ".div_select.active ul" ).scroll(function () {

            let height = $( this ).height();
            let scrollheight = $( this ).prop( "scrollHeight" );
            let scrollBottom = $( this ).scrollTop() - scrollheight + height + 10;

            if ( $( this ).scrollTop() == 0 ) {
                $( this ).scrollTop(1);
            } else if  ( scrollBottom == 0 ) {
                $( this ).scrollTop( $( this ).scrollTop() - 1 );
            }
        });
        /* end */

    });

    /* function close ul element if mouse click somewhere on document  */
    $(document).on( "click" , function(event){

        // if($( ".div_select" ).hasClass( "active" ) && $(event.target).closest( ".div_select" ).length == 0) {
        if( divSelect.hasClass( "active" ) && $(event.target).closest( ".div_select" ).length == 0) {
            // $( ".div_select" ).removeClass( "active" );
            divSelect.removeClass( "active" );
        }
    });




    /* get li object  */
    let divSelectUlLi = $( ".div_select ul li" );

    /* get hidden input object  */
    let hiddenInputFlag = $( "#hidden_input_flag" );

    /* get hidden image object  */
    let plateFlag = $( ".div_plate .plate_flag" );

    /* function select flag */
    // $( ".div_select ul li" ).on('click', function() {
    divSelectUlLi.on('click', function() {


        /* get class */
        let text = $( this ).find( ".plate_text" ).text();
        // $( ".div_select button" ).text( text );
        divSelectBtn.text( text );
        // $( "#hidden_input_flag" ).val( text );
        hiddenInputFlag.val( text );
        // $( ".div_select" ).removeClass( "active" );
        divSelect.removeClass( "active" );

        // let germanLicensePlateFlag = "{{ 'germany-flag.png' | file_img_url: '110x246' }}";
        // let germanCoatofArmsFlag = "{{ 'germany-coat-of-arms-flag.png' | file_img_url: '110x246' }}";
        // let usaFlag = "{{ 'usa-flag.png' | file_img_url: '110x246' }}";
        // let puertoRicoFlag = "{{ 'puerto-rico-flag.png' | file_img_url: '110x246' }}";
        // let mexicoFlag = "{{ 'mexico-flag.png' | file_img_url: '110x246' }}";
        // let japanRisingSunFlag = "{{ 'japan-rising-sun-flag.png' | file_img_url: '110x246' }}";
        // let greatBritainFlag = "{{ 'great-britain-flag.png' | file_img_url: '110x246' }}";

/*
        let flags = {
            "German License Plate": "//cdn.shopify.com/s/files/1/0578/0334/1963/files/germany-flag_110x246.png?v=1651006750",
            "German Coat of Arms": "//cdn.shopify.com/s/files/1/0578/0334/1963/files/germany-coat-of-arms-flag_110x246.png?v=1651006750",
            "USA": "//cdn.shopify.com/s/files/1/0578/0334/1963/files/usa-flag_110x246.png?v=1651006773",
            "Puerto Rico" : "//cdn.shopify.com/s/files/1/0578/0334/1963/files/puerto-rico-flag_110x246.png?v=1651006773",
            "Mexico" : "//cdn.shopify.com/s/files/1/0578/0334/1963/files/mexico-flag_110x246.png?v=1651006774",
            "Japan Rising Sun": "//cdn.shopify.com/s/files/1/0578/0334/1963/files/japan-rising-sun-flag_110x246.png?v=1651006288",
            "Great Britain" : "//cdn.shopify.com/s/files/1/0578/0334/1963/files/great-britain-flag_110x246.png?v=1651006774"

        }*/

        let flags = {
            "German License Plate": germanLicensePlateFlag,
            "German Coat of Arms": germanCoatofArmsFlag,
            "USA": usaFlag,
            "Puerto Rico" : puertoRicoFlag,
            "Mexico" : mexicoFlag,
            "Japan Rising Sun": japanRisingSunFlag,
            "Great Britain" : greatBritainFlag
        }

        if ( text == "No Flag" ) {
            // $( ".div_plate .plate_flag" ).addClass( "no_flag" );
            plateFlag.addClass( "no_flag" );


            // backgrLayer.css( "border-radius", '10px' );
            // backgrLayer.addClass( "div_plate_text_without_flag" );



        } else {

            // $( ".div_plate .plate_flag" ).attr("src", flags[text]);
            plateFlag.attr("src", flags[text]);

            // if ( $( ".div_plate .plate_flag" ).hasClass( "no_flag" ) ) {
            if ( plateFlag.hasClass( "no_flag" ) ) {
                // $( ".div_plate .plate_flag" ).removeClass( "no_flag" )
                plateFlag.removeClass( "no_flag" )



                // backgrLayer.css( "border-radius", '' );
                // backgrLayer.removeClass( "div_plate_text_without_flag" )


            }
        }
    });


    /* document ready fumction end  */
});